/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

// Material-UI components
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import apiClient from "../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Divider from "@mui/material/Divider";
import MDInput from "components/MDInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

// Define the Job component
const Job = ({ title, description }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography display="block" variant="caption" fontWeight="medium">
      {title}
    </MDTypography>
    <MDTypography variant="caption">{description}</MDTypography>
  </MDBox>
);

const Author = ({ image, name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDAvatar src={image} name={name} size="sm" />
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

const FetchLandlordData = ({ onRefresh }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [statusInput, setStatusInput] = useState("Active");
  const [nameFilter, setNameFilter] = useState("");
  const [phoneFilter, setPhoneFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // Fetch data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/landlord");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching landlord data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [onRefresh]);

  // Handlers
  const handleActivate = async (id, status) => {
    try {
      await apiClient.put(`/admin/landlord/${id}`, { status: status });
      fetchData(); // Refresh data after status update
    } catch (error) {
      console.error("Error activating landlord:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/admin/landlord/${id}`);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting landlord:", error);
    }
  };

  const handleEdit = (id) => {
    // Handle edit functionality
    console.log("Edit landlord with ID:", id);
  };

  const handleNameInputChange = (event) => {
    setName(event.target.value);
  };

  const handlePhoneInputChange = (event) => {
    setPhone(event.target.value);
  };

  const handleCityInputChange = (event) => {
    setCity(event.target.value);
  };

  const handleStatusInputChange = (event) => {
    setStatusInput(event.target.value);
  };

  const handleFilterSubmit = () => {
    setNameFilter(name);
    setPhoneFilter(phone);
    setCityFilter(city);
    setStatusFilter(statusInput);
  };

  const handleClearFilters = () => {
    setNameFilter("");
    setPhoneFilter("");
    setCityFilter("");
    setStatusFilter("");
    setName("");
    setPhone("");
    setCity("");
    setStatusInput("Active");
  };

  // Filter data
  const filteredRows = data.filter((row) => {
    return (
      (nameFilter === "" || row.name.toLowerCase().includes(nameFilter.toLowerCase())) &&
      (phoneFilter === "" || row.phone.toLowerCase().includes(phoneFilter.toLowerCase())) &&
      (cityFilter === "" || row.city.toLowerCase().includes(cityFilter.toLowerCase())) &&
      (statusFilter === "" || row.status.toLowerCase().includes(statusFilter.toLowerCase()))
    );
  });

  const columns = [
    { Header: "Name", accessor: "name", width: "25%", align: "left" },
    { Header: "Mobile", accessor: "phone", align: "center" },
    { Header: "City", accessor: "city", align: "center" },
    { Header: "Address", accessor: "address", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = filteredRows.map((data) => ({
    name: <Author image={team2} name={data.station_name} email={data.email} />,
    mobile: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.email}
      </MDTypography>
    ),
    city: <Job title={data.city} description={data.state} />,
    address: <Job title={data.address} description={data.district} />,
    image: <MDAvatar src={team2} name={data.images} size="sm" />,
    status: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={data.status}
          color={data.status === "Active" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    phone: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.phone}
      </MDTypography>
    ),
    city: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.city}
      </MDTypography>
    ),
    address: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {data.address}
      </MDTypography>
    ),
    action: (
      <MDBox display="flex" justifyContent="space-around">
        <IconButton onClick={() => handleEdit(data._id)} color="secondary">
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={() => handleActivate(data._id, data.status)}
          color={data.status === "Active" ? "warning" : "success"}
        >
          <CheckCircleIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(data._id)} color="error">
          <DeleteIcon />
        </IconButton>
      </MDBox>
    ),
  }));
  // No data message
  if (loading) return <div>Loading...</div>;
  if (data.length === 0) return <div>No data found.</div>;

  return (
    <div>
      <MDBox
        display="flex"
        gap="1rem"
        mb="1rem"
        justifyContent="left"
        alignItems="left"
        ml="2%"
        width="90%"
      >
        <MDInput
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={handleNameInputChange}
        />
        <MDInput
          fullWidth
          label="Phone"
          variant="outlined"
          value={phone}
          onChange={handlePhoneInputChange}
        />
        <MDInput
          fullWidth
          label="City"
          variant="outlined"
          value={city}
          onChange={handleCityInputChange}
        />
        <Select
          fullWidth
          variant="outlined"
          value={statusInput}
          onChange={handleStatusInputChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>Status</em>
          </MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{ color: "#fff" }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClearFilters}
          sx={{ color: "#fff" }}
        >
          Clear
        </Button>
      </MDBox>
      <Divider />
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
      />
    </div>
  );
};
FetchLandlordData.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};

export default FetchLandlordData;
